// extracted by mini-css-extract-plugin
export default {"form":"Subscribe_form__newzi","input":"Subscribe_input__bjLil","btn":"Subscribe_btn__5557L"};